import { Outlet, createRootRoute } from '@tanstack/react-router';
import { Toaster } from 'sonner';

export const Route = createRootRoute({
  component: () => (
    <>
      <Outlet />
      {/* Toast dùng cho thông báo SSE và kết quả mutation. `richColors` để
          thành công/lỗi phân biệt được bằng màu *và* icon. */}
      <Toaster position="bottom-right" richColors closeButton />
    </>
  ),
});
